import React from "react";
import { useSelector } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import EmailBlockBuilder from "./EmailBlockBuilder";
import CampaignEmailContainer from "./CampaignEmailContainer";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    width: "100%",
  },
  paper: {
    padding: "20px",
    margin: "20px",
    textAlign: "left",
    minHeight: "400px",
    overflowY: "scroll",
    width: "100%",
    backgroundColor: "#e0e0e0",
  },
}));

export default function EventMailContainer() {
  const classes = useStyles();
  const atleteAccount = useSelector((state) => state.atlete.atleteAccount);
  const esPerfilUno = atleteAccount && atleteAccount.perfil === 1;

  return (
    <Paper className={classes.paper}>
      <div className={classes.root}>
        <Grid container direction="row" alignItems="flex-start">
          <Grid item xs={12}>
            <Typography gutterBottom variant={"h2"} component="h2">
              Configuración de Correo
            </Typography>
          </Grid>
          {esPerfilUno && (
            <Grid item xs={12}>
              <CampaignEmailContainer />
            </Grid>
          )}
          <Grid item xs={12}>
            <EmailBlockBuilder />
          </Grid>
        </Grid>
      </div>
    </Paper>
  );
}
